import React from 'react';

const Search = ({ handleSearch, placeholder }) => {
  return (
    <div className="relative">
      <div className="flex items-center bg-white !rounded-2xl border border-gray-300 px-4 py-3.5 shadow-sm">
        <svg
          className="w-8 h-8 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>

        <input
          className="w-full geomanistMedium ml-3 text-xl text-gray-700 placeholder-gray-400 outline-none bg-transparent"
          type="text"
          placeholder={placeholder}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>
    </div>
  );
};

export default Search;
